import { IObservableQuery, injectSubject } from '@aesop-fables/scrinium';
import { CourseData, LessonData, PublicationStatusEnum } from '../../../models/CourseData';
import { LearningServices } from '../LearningServiceModule';
import { Observable, map, of } from 'rxjs';
import { findLessonSource } from '../commands/utils';
import { LessonQueryParams } from './FindActiveLessonById';

export class FindDraftByLessonId implements IObservableQuery<
  LessonQueryParams | undefined,
  LessonData | undefined
> {
  constructor(
    @injectSubject(LearningServices.Courses) private readonly courses: Observable<CourseData[]>,
  ) {}

  execute(params: LessonQueryParams | undefined): Observable<LessonData | undefined> {
    if (
      !params ||
      params.unitId === undefined ||
      isNaN(params.unitId) ||
      params.originalLessonId === undefined ||
      isNaN(params.originalLessonId)
    ) {
      return of(undefined);
    }

    const { unitId, originalLessonId } = params;

    return this.courses.pipe(
      map(courses => {
        const { courseIndex, unitIndex } = findLessonSource(
          { unitId: unitId, lessonId: originalLessonId },
          courses,
        );
        if (courseIndex !== -1 && typeof unitIndex !== 'undefined') {
          const course = courses[courseIndex];
          const unit = course.units?.at(unitIndex);
          const lesson = unit?.lessons?.find(
            x =>
              x.originalLessonId === originalLessonId && x.status === PublicationStatusEnum.DRAFT,
          );
          return lesson;
        }
      }),
    );
  }
}
